import { getData, getTimestampData } from "@/components/report/service";
import ActualDetail from "@/Entity/ActualDetail";
import RouteEntity from "@/Entity/RouteEntity";
import Queryable from "@/Entity/Tools/Queryable";
import { Result } from "@/Entity/Tools/Result";
import GenerateCondit, { Bound, IGnerCondit } from '@/models/GenerateCondit';
import { Aggregator, CountTicket } from "@/models/GenerateCondit/Interrelated";
import { crudRequest } from "@/services/api";
import moment from "moment";

const endDateFormat = 'YYYY-MM-DD 00:00:00'
const params = {
  startDate: moment().add(-1, 'days').format('YYYY-MM-01 00:00:00'),
  endDate: moment().add(-1, 'days').format(endDateFormat),
}

export default {
  namespace: 'waybillcashratenationwide',
  state: {
    searchParams: { ...params },
    productLinType: '',
    dataList: [],
    totalRow: {},
    dataSql: '',

    productDataList: [],
    productDataSql: '',

    timestamps: [],
  },

  effects: {
    *getData(_, { put, call, select }) {
      crudRequest('/api/route/waybillCashRateNationwide/search')
      const { searchParams, productLinType } = yield select(({ waybillcashratenationwide }) => waybillcashratenationwide)
      let { startDate, endDate } = searchParams
      endDate = moment(endDate).add(1, 'days').format(endDateFormat)
      const { key, value, alias } = productLinType
      // 用于查找匹配相同省区的谓词[=出发省区]
      const byOriginProvArea = (compar: ActualDetail): Result<ActualDetail, boolean> => {
        return (item) => item.originProvinceArea === compar.originProvinceArea;
      }

      // 默认实际签收票数查询条件
      const gcNewParam: IGnerCondit = {
        dataSource: 'actual_time_consume_result',
        dimensions: ['originProvinceArea'],
        aggregators: [CountTicket],
        startDate, //endDate,
        endDate: moment(endDate).add(1, 'days').format(endDateFormat),
      }
      const gc = new GenerateCondit<ActualDetail>(gcNewParam)
      gcNewParam.dataSource = 'route_plan_optimal_result'
      gcNewParam.endDate = endDate
      let entity = new ActualDetail({ [key]: value })
      const gcPlan = new GenerateCondit<RouteEntity>(gcNewParam)
      const entityPlan = new RouteEntity({ [key]: value, ticket: 1, scanType: '签收' })

      let data = [], condit

      //#region  累积规划签收 monthSumTicket
      condit = gcPlan.converCondit(entityPlan)
      data = yield getData(condit)
      /** 累积规划签收 */
      const monthSumTicket_data = new Queryable<ActualDetail>(data)
      //#endregion

      //#region 此处查询已兑现用于计算: 月累计兑现率    monthSumHonorRate
      entity.onTime = '是'
      gc.startDateAdd(-15)
      const bound = new Bound('theorySignDate', startDate, endDate)
      gc.setBoundFilters([bound])
      condit = gc.converCondit(entity)
      data = yield getData(condit)
      gc.setBoundFilters([])
      /** 月累计已兑现 */
      const monthSumHonorRate_data = new Queryable<ActualDetail>(data)
      //#endregion

      //#region  累计未兑现   monthSumNoHonor
      // entity.onTime = '否'
      // condit = gc.converCondit(entity)
      // data = yield getData(condit)
      /** 累计未兑现 */
      // const monthSumNoHonor_data = new Queryable<ActualDetail>(data)

      const monthSumNoHonor_data = monthSumTicket_data.maps(month => {
        const findItem = monthSumHonorRate_data.finds(byOriginProvArea(month))?.ticket || 0
        return { ...month, ticket: month.ticket - findItem }
      })
      //#endregion

      /** ------时间切换为选择时间当天------ */
      /** -------------------------------- */
      const oneDayTime = moment(endDate).add(-1, 'days').format('YYYY-MM-DD 00:00:00')
      gc.setDateime([oneDayTime])
      entity = new ActualDetail({ [key]: value })
      gcPlan.setDateime([oneDayTime])
      /** -------------------------------- */
      /** -------------------------------- */

      //#region当日规划签收  toDaySign
      // entity.onTime = ['是', '否']
      condit = gcPlan.converCondit(entityPlan)
      data = yield getData(condit)
      /** 当日规划兑现 */
      const toDaySign_data = new Queryable<ActualDetail>(data)
      //#endregion

      //#region 此处查询已兑现用于计算: 当日兑现率  toDaySignHonorRate
      entity.onTime = '是'
      gc.startDateAdd(-15)
      const boundDay = new Bound('theorySignDate', oneDayTime, endDate)
      gc.setBoundFilters([boundDay])
      condit = gc.converCondit(entity)
      data = yield getData(condit)
      /** 当日已兑现 */
      const toDaySignHonorRate_data = new Queryable<ActualDetail>(data)
      //#endregion

      //#region当日未兑现   toDaySignNoHonor
      // entity.onTime = '否'
      // condit = gc.converCondit(entity)
      // data = yield getData(condit)
      // /** 当日未兑现 */
      // const toDaySignNoHonor_data = new Queryable<ActualDetail>(data)

      const toDaySignNoHonor_data = toDaySign_data.maps(month => {
        const findItem = toDaySignHonorRate_data.finds(byOriginProvArea(month))?.ticket || 0
        return { ...month, ticket: month.ticket - findItem }
      })
      //#endregion

      const converRate = (dividens, divisor) => {
        return (divisor ? (dividens / (divisor) * 100).toFixed(0) + '%' : '--')
      }
      const totalRow = {
        monthSumTicket: 0, monthSumNoHonor: 0, monthSumHonor: 0,
        toDaySign: 0, toDaySignNoHonor: 0, toDaySignHonor: 0,
        monthSumHonorRate: '', toDaySignHonorRate: ''
      }
      const dataList = monthSumTicket_data.maps((monthST, i) => {
        // 以累积规划签收为基准,各项集合中找到与之相匹配的[出发省区]
        const monthSumNoHonor = monthSumNoHonor_data.finds(byOriginProvArea(monthST))?.ticket || 0      // 累积未兑现
        const monthSumHonor = monthSumHonorRate_data.finds(byOriginProvArea(monthST))?.ticket || 0      // 累积已签收
        const monthSumHonorRate = converRate(monthSumHonor, monthST.ticket)                             // 累积签收率(%)
        const toDaySign = toDaySign_data.finds(byOriginProvArea(monthST))?.ticket || 0                  // 当日规划签收
        const toDaySignNoHonor = toDaySignNoHonor_data.finds(byOriginProvArea(monthST))?.ticket || 0    // 当日未签收
        const toDaySignHonor = toDaySignHonorRate_data.finds(byOriginProvArea(monthST))?.ticket || 0    // 当日已签收
        const toDaySignHonorRate = converRate(toDaySignHonor, toDaySign)                                // 当日签收率(%)

        // 汇总
        totalRow.monthSumTicket += monthST.ticket
        totalRow.monthSumNoHonor += monthSumNoHonor
        totalRow.monthSumHonor += monthSumHonor
        totalRow.toDaySign += toDaySign
        totalRow.toDaySignNoHonor += toDaySignNoHonor
        totalRow.toDaySignHonor += toDaySignHonor
        return {
          originProvinceArea: monthST.originProvinceArea,
          monthSumTicket: monthST.ticket,
          monthSumNoHonor, monthSumHonorRate,
          toDaySign, toDaySignNoHonor, toDaySignHonorRate,
        }
      })
      totalRow.monthSumHonorRate = converRate(totalRow.monthSumHonor, totalRow.monthSumTicket)
      totalRow.toDaySignHonorRate = converRate(totalRow.toDaySignHonor, totalRow.toDaySign)

      yield put({ type: 'updateState', payload: { dataList, totalRow } })
    },
    *getProduct(_, { put, call, select }) {
      const { searchParams, productLinType } = yield select(({ waybillcashratenationwide }) => waybillcashratenationwide)
      const { startDate, endDate } = searchParams
      const { key, value, alias } = productLinType

      //#region 查询条件
      // 计划表
      const gcPlan = new GenerateCondit<RouteEntity>({
        dataSource: 'route_plan_optimal_result',
        dimensions: null,
        aggregators: [new Aggregator('count', 'count', 'waybillNo')],
        // startDate,
        startDate,//: moment(startDate).add(0, 'days').format(endDateFormat),
        endDate: moment(endDate).add(1, 'days').format(endDateFormat),
        queryType: 'timeSeries', simpleGranularity: 'day'
      })
      // 实际表
      const gc = new GenerateCondit<ActualDetail>({
        dataSource: 'actual_time_consume_result',
        dimensions: ['theorySignDate'],
        aggregators: [CountTicket],
        // aggregators: [TICKET],
        // startDate,
        startDate: moment(startDate).add(-15, 'days').format(endDateFormat),
        endDate: moment(endDate).add(2, 'days').format(endDateFormat),
        queryType: 'groupBy',
      })
      //#endregion

      //#region 全部数据
      const entityAll = new RouteEntity({ [key]: value, ticket: 1, scanType: '签收' })
      let condit = gcPlan.converCondit(entityAll)
      const dataAll = yield getTimestampData(condit)
      //#endregion

      //#region 兑现数据
      const entity = new ActualDetail({ [key]: value, onTime: '是' })
      const bound = new Bound(
        'theorySignDate',
        startDate, moment(endDate).add(1, 'days').format(endDateFormat)
        // moment(endDate).add(1, 'days').format('YYYY-MM-DD 12:00:01'),
      )
      gc.setBoundFilters([bound])
      condit = gc.converCondit(entity)
      const dataOnTime = yield getData(condit)
      //#endregion
      //#region 兑现率

      const RedemptionRate = dataAll.map((allItem) => {
        const actualItem = dataOnTime.find(item => {
          const allItemTime = moment(allItem.timestamp).format('YYYY-MM-DD')
          const itemTime = moment(item.theorySignDate).format('YYYY-MM-DD')
          // console.log('time', allItemTime, itemTime, allItemTime === itemTime)
          return allItemTime === itemTime
        })
        if (!actualItem) return 0
        const ratio = (actualItem.ticket / allItem.count)
        return ratio ? Number.parseInt((ratio * 100).toFixed(0)) : 0
      })
      //#endregion
      const timestamps = dataAll.map(m => moment(m.timestamp).format('YYYY-MM-DD'))
      const productDataList = [{ name: `${alias || '全产品'}(%)`, value: RedemptionRate }]
      // if (value) {
      //     productDataList.push({ name: value, value: RedemptionRate })
      // }
      yield put({
        type: 'updateState',
        payload: { productDataList, timestamps }
      })
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  }
}
